import { __extends } from "tslib";
import { SubscribeToShardInput, SubscribeToShardOutput } from "../models/models_0";
import { deserializeAws_json1_1SubscribeToShardCommand, serializeAws_json1_1SubscribeToShardCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var SubscribeToShardCommand = /** @class */ (function (_super) {
    __extends(SubscribeToShardCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function SubscribeToShardCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    SubscribeToShardCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "KinesisClient";
        var commandName = "SubscribeToShardCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: SubscribeToShardInput.filterSensitiveLog,
            outputFilterSensitiveLog: SubscribeToShardOutput.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    SubscribeToShardCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1SubscribeToShardCommand(input, context);
    };
    SubscribeToShardCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1SubscribeToShardCommand(output, context);
    };
    return SubscribeToShardCommand;
}($Command));
export { SubscribeToShardCommand };
//# sourceMappingURL=SubscribeToShardCommand.js.map